/* Simulations℠ /testimony — wall fetch + render.
 * Replaces hardcoded sample with live data from sim-testify Worker.
 * Hooks into the existing sim-testimony.liquid section markup.
 *
 * Loaded via <script> from sim-testimony.liquid section.
 * Vanilla JS. No deps.
 */
(function () {
  'use strict';

  // Guard: this script can be loaded by both sim-testimony.liquid (the /testimony
  // wall) and sim-marquee.liquid (standalone marquee). If both sections are on one
  // page, the file loads twice — run only once.
  if (window.__simTestimonyInit) return;
  window.__simTestimonyInit = true;

  const API_BASE = 'https://www.simulations.so/api/testimonies';

  // ── Marquee live-data hydration (runs on any page with .mq) ────────────
  // Replaces the hardcoded fallback tiles with API data when available.
  async function hydrateMarquees() {
    const rows = document.querySelectorAll('.mq__row');
    if (!rows.length) return;
    let testimonies;
    try {
      const res = await fetch(API_BASE + '?on_marquee=true');
      const data = await res.json();
      testimonies = (data.testimonies || []).filter((t) => t.tier === 'tier_1');
      if (!testimonies.length) return;
    } catch (err) { console.error('Marquee fetch error:', err); return; }
    const escMq = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const tile = (t) => {
      // Render the actual pfp as an <img> (like the /testimony wall) so it
      // object-fit: covers the frame. background-image had no cover sizing,
      // which showed a zoomed top-left crop of the source photo.
      const photo = t.photo_url
        ? `<div class="mq-photo mq-photo--filled" aria-hidden="true"><img src="${escMq(t.photo_url)}" alt="" loading="lazy" decoding="async"></div>`
        : `<div class="mq-photo" aria-hidden="true"></div>`;
      const role = t.occupation && t.company ? `${escMq(t.occupation)}, ${escMq(t.company)}` : escMq(t.occupation || t.company || '');
      // Capitalise the first letter (DB snippets are stored lowercase), then wrap
      // in curly quotes to match the editorial voice of the /testimony wall.
      const rawSnippet = (t.snippet || t.testimony || '').trim();
      const snippet = rawSnippet.charAt(0).toUpperCase() + rawSnippet.slice(1);
      return `
        <div class="mq-tile">
          ${photo}
          <div class="mq-text">
            <p class="mq-snippet">“${mdRender(snippet)}”</p>
            <p class="mq-attr">
              <span class="mq-name">${escMq(t.name)}</span>
              ${role ? `<span class="mq-title">${role}</span>` : ''}
            </p>
          </div>
        </div>`;
    };
    // Render each row with tiles twice (seamless loop)
    const doubled = testimonies.concat(testimonies).map(tile).join('');
    rows.forEach((row) => {
      row.innerHTML = doubled;
      // iOS Safari drops a running CSS animation when the animated element's
      // children are replaced — which froze the marquee a few seconds after
      // load, once the API content swapped in over the fallback tiles. Restart
      // the animation. Toggle only animation-name so the inline
      // animation-duration (the section's Speed setting) is preserved.
      row.style.animationName = 'none';
      void row.offsetWidth; // force reflow so the restart registers
      row.style.animationName = '';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateMarquees);
  } else {
    hydrateMarquees();
  }

  // ── Wall fetch + render (runs only on /testimony) ─────────────────────
  const shell = document.querySelector('.ty-shell');
  if (!shell) return;

  // Active filter + pagination
  let activeFilter = 'all'; // 'all' | 'simulations' | 'pastlife'
  const PAGE_SIZE = 12;
  let displayedCount = PAGE_SIZE;

  // ── Fetch (NO query strings — CF/Shopify routing quirk forces server-side
  //    filtering off the table. Pull all approved, filter client-side.) ────
  let cachedTestimonies = null;
  async function fetchTestimonies(filter) {
    if (cachedTestimonies === null) {
      try {
        const res = await fetch(API_BASE);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Fetch failed');
        cachedTestimonies = data.testimonies || [];
      } catch (err) {
        console.error('Testimony fetch error:', err);
        return null;
      }
    }
    if (filter === 'pastlife') {
      return cachedTestimonies.filter((t) => (t.simulation || '').toLowerCase().includes('pastlife'));
    }
    if (filter === 'simulations') {
      return cachedTestimonies.filter((t) => (t.simulation || '').toLowerCase().startsWith('simulations'));
    }
    return cachedTestimonies;
  }

  // ── Render helpers ─────────────────────────────────────────────────────
  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* mdRender · Minimal markdown for testimony quotes + marquee snippets.
   * Supported: **bold**  *italic*  [text](url).
   * HTML is escaped FIRST, then markdown patterns are applied — so admin
   * cannot inject raw HTML (e.g. <script>) by typing it in the editor.
   * Links: http(s):// external OR /relative-path internal. Anything else
   * is rejected (the [text](url) pattern won't match). */
  function mdRender(s) {
    if (s == null) return '';
    let out = String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
    // Bold BEFORE italic so ** isn't eaten as two *italics*
    out = out.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>');
    out = out.replace(/\*([^*\n]+)\*/g, '<em>$1</em>');
    // Link: [text](url) — optional whitespace between ] and ( for forgiving authoring.
    // URL must be http(s):// or start with / (rejects javascript:/data:/etc).
    out = out.replace(
      /\[([^\]\n]+)\]\s*\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g,
      '<a class="ty-link" href="$2">$1</a>'
    );
    return out;
  }

  function renderAudioPlayer(audioUrl) {
    if (!audioUrl) return '';
    return `
      <div class="ty-audio ty-audio--playing" data-audio-player>
        <button class="ty-audio__pause" aria-label="Play recording" data-audio-toggle>
          <svg class="ty-audio__icon-play" width="10" height="12" viewBox="0 0 10 12" aria-hidden="true">
            <path d="M0 0 L10 6 L0 12 Z" fill="currentColor"/>
          </svg>
          <span class="ty-audio__icon-pause" style="display:none;">
            <span class="ty-audio__bar"></span><span class="ty-audio__bar"></span>
          </span>
        </button>
        <div class="ty-audio__track" data-audio-track>
          <div class="ty-audio__progress" data-audio-progress style="width:0%">
            <span class="ty-audio__head"></span>
          </div>
        </div>
        <span class="ty-audio__time" data-audio-time>0:00</span>
        <audio data-audio-el preload="metadata" src="${esc(audioUrl)}" style="display:none"></audio>
      </div>`;
  }

  function renderStandardEntry(t) {
    // city is admin-gated via show_city; Worker strips it when hidden.
    const roleCompany = [t.occupation, t.company].filter(Boolean).map(esc).join(', ');
    return `
      <article class="ty-entry ty-entry--standard">
        <blockquote class="ty-quote">"${mdRender(t.testimony)}"</blockquote>
        ${renderAudioPlayer(t.audio_url)}
        <p class="ty-attr">
          <span class="ty-attr__name">${esc(t.name)}</span>
          ${roleCompany ? `· <span>${roleCompany}</span>` : ''}
          ${t.city ? `· <span>${esc(t.city)}</span>` : ''}
        </p>
      </article>
    `;
  }

  function renderTier1Entry(t) {
    const initials = (t.name || '')
      .split(' ')
      .map((w) => w[0])
      .filter(Boolean)
      .join('')
      .toUpperCase()
      .slice(0, 2);
    const photo = t.photo_url
      ? `<div class="ty-pfp"><img src="${esc(t.photo_url)}" alt="" loading="lazy" decoding="async"></div>`
      : `<div class="ty-pfp" style="background:#2a3a55" aria-hidden="true"><span>${esc(initials)}</span></div>`;

    return `
      <article class="ty-entry ty-entry--standard ty-entry--tier1">
        <blockquote class="ty-quote">"${mdRender(t.testimony)}"</blockquote>
        <div class="ty-attr-row">
          ${photo}
          <p class="ty-attr ty-attr--tier1">
            <span class="ty-attr__name">${esc(t.name)}</span><br>
            <span class="ty-attr__role">${esc(t.occupation || '')}${t.company ? `, ${esc(t.company)}` : ''}</span>
            ${t.city ? `· <span class="ty-attr__loc">${esc(t.city)}</span>` : ''}
          </p>
        </div>
      </article>
    `;
  }

  function renderEntry(t) {
    if (t.tier === 'tier_1') return renderTier1Entry(t);
    return renderStandardEntry(t);
  }

  function renderEmpty() {
    return `
      <div class="ty-empty">
        <p class="ty-empty__line">No testimonies yet.</p>
        <p class="ty-empty__sub">Coming soon.</p>
      </div>
    `;
  }

  function renderError() {
    return `
      <div class="ty-empty">
        <p class="ty-empty__line">Couldn't reach the wall.</p>
        <button class="t-textlink" type="button" data-t-action="refresh">
          <span class="t-textlink__rule"></span>
          refresh
          <span class="t-textlink__arrow">↻</span>
        </button>
      </div>
    `;
  }

  function renderLoading() {
    let html = '';
    for (let i = 0; i < 3; i++) {
      html += `
        <article class="ty-entry ty-entry--skeleton">
          <div class="ty-skel ty-skel--quote">
            <span style="width: 94%"></span>
            <span style="width: 88%"></span>
            <span style="width: 40%"></span>
          </div>
          <div class="ty-skel ty-skel--attr">
            <span style="width: 32%"></span>
          </div>
        </article>
      `;
    }
    return html;
  }

  // ── Pill counts ─────────────────────────────────────────────────────────
  function updatePillCounts() {
    if (cachedTestimonies === null) return;
    const all = cachedTestimonies.length;
    const sims = cachedTestimonies.filter(t => (t.simulation || '').toLowerCase().startsWith('simulations')).length;
    const pl = cachedTestimonies.filter(t => (t.simulation || '').toLowerCase().includes('pastlife')).length;
    shell.querySelectorAll('[data-count="all"]').forEach(el => el.textContent = all);
    shell.querySelectorAll('[data-count="simulations"]').forEach(el => el.textContent = sims);
    shell.querySelectorAll('[data-count="pastlife"]').forEach(el => el.textContent = pl);
  }

  // ── Wall update ────────────────────────────────────────────────────────
  async function updateWall() {
    const defaultPanel = shell.querySelector('[data-ty-state="default"] .ty-wall');
    if (!defaultPanel) return;
    const moreWrap = shell.querySelector('[data-ty-more]');

    defaultPanel.innerHTML = renderLoading();
    if (moreWrap) moreWrap.style.display = 'none';

    const testimonies = await fetchTestimonies(activeFilter);
    updatePillCounts();

    if (testimonies === null) {
      defaultPanel.innerHTML = renderError();
      bindRefresh(defaultPanel);
      return;
    }

    if (testimonies.length === 0) {
      defaultPanel.innerHTML = renderEmpty();
      return;
    }

    // Pagination: render first `displayedCount` only.
    const visible = testimonies.slice(0, displayedCount);
    defaultPanel.innerHTML = visible.map(renderEntry).join('');

    // Toggle "more" button visibility.
    if (moreWrap) {
      moreWrap.style.display = (testimonies.length > displayedCount) ? '' : 'none';
    }

    bindAudioPlayers(defaultPanel);

    // Update count if shown
    const countEl = shell.querySelector('.ty-head__count');
    if (countEl) {
      const padded = String(testimonies.length).padStart(3, '0');
      countEl.textContent = `${padded} testimonies on file`;
    }
  }

  // ── Audio player wiring (full pill with track + time) ─────────────────
  function fmtTime(s) {
    if (!isFinite(s) || isNaN(s) || s < 0) return '0:00';
    const m = Math.floor(s / 60);
    const sec = String(Math.floor(s % 60)).padStart(2, '0');
    return `${m}:${sec}`;
  }
  function bindAudioPlayers(scope) {
    scope.querySelectorAll('[data-audio-player]').forEach((wrap) => {
      const audio = wrap.querySelector('[data-audio-el]');
      const btn = wrap.querySelector('[data-audio-toggle]');
      const track = wrap.querySelector('[data-audio-track]');
      const progress = wrap.querySelector('[data-audio-progress]');
      const timeEl = wrap.querySelector('[data-audio-time]');
      const playIcon = wrap.querySelector('.ty-audio__icon-play');
      const pauseIcon = wrap.querySelector('.ty-audio__icon-pause');
      if (!audio || !btn) return;

      audio.addEventListener('loadedmetadata', () => {
        timeEl.textContent = `0:00 / ${fmtTime(audio.duration)}`;
      });
      audio.addEventListener('timeupdate', () => {
        if (audio.duration > 0) {
          progress.style.width = `${(audio.currentTime / audio.duration) * 100}%`;
          timeEl.textContent = `${fmtTime(audio.currentTime)} / ${fmtTime(audio.duration)}`;
        }
      });
      audio.addEventListener('ended', () => {
        playIcon.style.display = '';
        pauseIcon.style.display = 'none';
        progress.style.width = '0%';
        audio.currentTime = 0;
        wrap.classList.remove('is-playing');
      });
      btn.addEventListener('click', () => {
        // Pause any other playing audio first
        document.querySelectorAll('[data-audio-el]').forEach((a) => {
          if (a !== audio && !a.paused) {
            a.pause();
            const w = a.closest('[data-audio-player]');
            if (w) {
              w.querySelector('.ty-audio__icon-play').style.display = '';
              w.querySelector('.ty-audio__icon-pause').style.display = 'none';
              w.classList.remove('is-playing');
            }
          }
        });
        if (audio.paused) {
          audio.play().catch((err) => console.error('Audio play error:', err));
          playIcon.style.display = 'none';
          pauseIcon.style.display = '';
          wrap.classList.add('is-playing');
        } else {
          audio.pause();
          playIcon.style.display = '';
          pauseIcon.style.display = 'none';
          wrap.classList.remove('is-playing');
        }
      });
      track.addEventListener('click', (e) => {
        if (!audio.duration) return;
        const rect = track.getBoundingClientRect();
        const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        audio.currentTime = pct * audio.duration;
      });
    });
  }

  function bindRefresh(container) {
    const btn = container.querySelector('[data-t-action="refresh"]');
    if (btn) {
      btn.addEventListener('click', () => updateWall());
    }
  }

  // ── Filter pills ───────────────────────────────────────────────────────
  function bindPills() {
    shell.querySelectorAll('.ty-pill[data-filter]').forEach((pill) => {
      if (pill.disabled) return;
      pill.addEventListener('click', () => {
        activeFilter = pill.getAttribute('data-filter') || 'all';
        displayedCount = PAGE_SIZE; // reset pagination on filter change
        shell.querySelectorAll('.ty-pill').forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        updateWall();
      });
    });
  }

  // ── "more" button → load next page ─────────────────────────────────────
  function bindMore() {
    const btn = shell.querySelector('[data-ty-more-btn]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      displayedCount += PAGE_SIZE;
      updateWall();
    });
  }

  function init() {
    bindPills();
    bindMore();
    // Only fetch if we're on the default state (skip preview states which use sample data)
    const previewParam = new URLSearchParams(location.search).get('preview');
    if (!previewParam || previewParam === 'default') {
      updateWall();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();